// extracted by mini-css-extract-plugin
module.exports =  {"card":"GUoF3Dt0TSuQDnZk9nYJ","description":"y9V2gswqoRAlJd7znuJI"};